import { render, staticRenderFns } from "./DialogLink.vue?vue&type=template&id=173880fe&"
import script from "./DialogLink.vue?vue&type=script&lang=js&"
export * from "./DialogLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports